export default "__VITE_ASSET__BIo4_Cyo__"